import { gqlOperation } from '…/app/common/rpc/gqlOperation.mts';

import DELETE_INTEGRATION_CREDENTIALS from './deleteIntegrationCredentials.gql';

interface DeleteIntegrationCredentialsInput {
  integrationId: string;
  workspaceId: string;
}

export function deleteIntegrationCredentials({
  integrationId,
  workspaceId,
}: DeleteIntegrationCredentialsInput): Promise<boolean> {
  return gqlOperation<{ success: boolean }>(DELETE_INTEGRATION_CREDENTIALS, {
    integrationId,
    workspaceId,
  })
    .then(({ success }) => success);
}
